import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { notifications } from "@mantine/notifications";
import { Switch } from "@mantine/core";
import { editWebhook } from "../../../../api/ConfigsApi";

const WebhookActivator = ({ item, setLoading }) => {
  const lang = useLanguage((s) => s.language);
  const [active, setActive] = useState(item?.enabled);
  const handleChange = () => {
    setLoading(true);
    editWebhook({ id: item.id, enabled: !active })
      .then(() => {
        setActive(!active);
        notifications.show({
          message: active ? "Webhook désactivé" : "Webhook activé",
          color: "tertiary.8",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setActive(item?.enabled);
  }, [item?.enabled]);

  return (
    <Switch
      checked={active}
      onChange={handleChange}
      color="tertiary.8"
      ml={"auto"}
      size="md"
    />
  );
};

export default WebhookActivator;
